import { Directive, Input } from '@angular/core';
import { FormControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[min][formControlName],[min][formControl], [min][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }
  ]
})
export class MinValidatorDirective implements Validator {
  @Input() min: number;

  constructor() {}

  validate(c: FormControl): { [key: string]: any } {
    return c.value < this.min ? { min: true } : null;
  }
}
